import MDSpinner from "react-md-spinner";
import THEMES from "../../../Util/dataModels/Themes";
import { useContext, useState } from "react";
import { AppContext } from "../../../Util/contexts/AppContext";

const Themes = () => {
  const {
    primaryColor,
    selectedThemeIndex,
    route,
    userData,
    displayAuthenticationError,
    setSelectedThemeIndex,
    setPrimaryColor,
  } = useContext(AppContext);
  const [themeChangeIndex, setThemeChangeIndex] = useState(-1);

  const { Token, CustomerId } = userData;

  const changeTheme = async (themeIndex, saveChange = true, userData) => {
    setSelectedThemeIndex(themeIndex);
    setPrimaryColor(THEMES[themeIndex].primaryColor);

    document.documentElement.style.setProperty(
      "--new-primary-color",
      THEMES[themeIndex].primaryColor
    );
    document.documentElement.style.setProperty(
      "--new-secondary-color",
      THEMES[themeIndex].secondaryColor
    );
    document.documentElement.style.setProperty(
      "--new-primary-background-color",
      THEMES[themeIndex].primaryBackgroundColor
    );
    document.documentElement.style.setProperty(
      "--new-secondary-background-color",
      THEMES[themeIndex].secondaryBackgroundColor
    );
    document.documentElement.style.setProperty(
      "--new-tertiary-background-color",
      THEMES[themeIndex].tertiaryBackgroundColor
    );
    document.documentElement.style.setProperty(
      "--new-off-background-color",
      THEMES[themeIndex].offBackgroundColor
    );
    document.documentElement.style.setProperty(
      "--new-text-color",
      THEMES[themeIndex].textColor
    );
    document.documentElement.style.setProperty(
      "--new-case-text-color",
      THEMES[themeIndex].caseTextColor
    );
    document.documentElement.style.setProperty(
      "--new-secondary-text-color",
      THEMES[themeIndex].secondaryTextColor
    );
    document.documentElement.style.setProperty(
      "--new-off-text-color",
      THEMES[themeIndex].offTextColor
    );
    document.documentElement.style.setProperty(
      "--new-secondary-off-text-color",
      THEMES[themeIndex].secondaryOffTextColor
    );
    document.documentElement.style.setProperty(
      "--new-tertiary-off-text-color",
      THEMES[themeIndex].tertiaryOffTextColor
    );
    document.documentElement.style.setProperty(
      "--case-selected-color",
      THEMES[themeIndex].caseSelectedColor
    );
    document
      .querySelector("meta[name=theme-color]")
      .setAttribute("content", THEMES[themeIndex].tertiaryBackgroundColor);

    if (saveChange) {
      setThemeChangeIndex(themeIndex);
      const response = await fetch(`${route}/changetheme.webapi`, {
        method: "POST",
        headers: {
          Token: Token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          Theme: themeIndex,
          CustomerId: CustomerId,
        }),
      });
      setThemeChangeIndex(-1);

      if (response.status === 401) {
        return displayAuthenticationError();
      }

      if (response.ok) {
        const apiMessage = await response.text();
      } else {
        console.log("error", response);
      }
    }
  };

  return (
    <div
      className="accountSettingsCard accountSettingsBigCard"
      key="Theme Card"
    >
      <h3 className="accountSettingsCardTitle">Theme</h3>
      <p className="accountSettingsToggleDescription">
        Personalize your studying by selected a theme that feels more like you.
      </p>
      <div className="accountSettingsThemeBreakLine" />
      {THEMES.map((theme, index) => (
        <div
          className="accountSettingsThemeWrapper"
          key={`theme #${index + 1}`}
        >
          <h4 className="accountSettingsThemeTitle">{theme.themeTitle}</h4>
          <p className="accountSettingsThemeDescription">
            {theme.themeDescription}
          </p>
          <div className="accountSettingsThemeColorSquaresContainer">
            <div
              className="accountSettingsThemeColorSquare"
              style={{ backgroundColor: theme.primaryColor }}
            />
            <div
              className="accountSettingsThemeColorSquare"
              style={{ backgroundColor: theme.secondaryColor }}
            />
            <div
              className="accountSettingsThemeColorSquare"
              style={{ backgroundColor: theme.primaryBackgroundColor }}
            />
            <div
              className="accountSettingsThemeColorSquare"
              style={{
                backgroundColor: theme.secondaryBackgroundColor,
              }}
            />
            <div
              className="accountSettingsThemeColorSquare"
              style={{ backgroundColor: theme.tertiaryBackgroundColor }}
            />
          </div>
          {themeChangeIndex === index ? (
            <div className="accountSettingsThemeSpinnerContainer">
              <MDSpinner size={30} singleColor={primaryColor} />
            </div>
          ) : (
            <button
              className={`accountSettingsThemeButton ${
                selectedThemeIndex === index
                  ? "accountSettingsThemeButtonActive"
                  : ""
              } ${
                themeChangeIndex !== -1 && themeChangeIndex !== index
                  ? "accountSettingsThemeButtonDisabled"
                  : ""
              }`}
              onClick={
                selectedThemeIndex === index
                  ? () => {}
                  : () => changeTheme(index)
              }
            >
              {selectedThemeIndex === index ? "Active" : "Activate"}
            </button>
          )}
        </div>
      ))}
    </div>
  );
};

export default Themes;
